__turbopack_context__.v({
  "closeBtn": "STSharePopover-module__T2jJMq__closeBtn",
  "copyLinkBox": "STSharePopover-module__T2jJMq__copyLinkBox",
  "shareBoxHeader": "STSharePopover-module__T2jJMq__shareBoxHeader",
  "sharePopoverContent": "STSharePopover-module__T2jJMq__sharePopoverContent",
  "socialIcon": "STSharePopover-module__T2jJMq__socialIcon",
});
